// extracted by mini-css-extract-plugin
export default {"center":"SearchingUsOnline_center__XB33+","header":"SearchingUsOnline_header__X6Jvs"};